<template>
  <div>
    <div class="row">
      <div class="col-12">
        <div class="card">
          <div class="card-body">
            <ValidationObserver
              v-if="agency"
              v-slot="{ handleSubmit, invalid, touched }"
              ref="updateForm"
            >
              <form
                class="authentication-form"
                @submit.prevent="handleSubmit(createAgency)"
              >
                <div class="row">
                  <div class="col-md-6">
                    <TextInput
                      v-model="agency.first_name"
                      name="first_name"
                      rules="required"
                      label="First Name"
                    />
                  </div>
                  <div class="col-md-6">
                    <TextInput
                      v-model="agency.last_name"
                      name="last_name"
                      rules="required"
                      label="Last Name"
                    />
                  </div>
                  <div class="col-md-6">
                    <TextInput
                      v-model="agency.name"
                      name="company_name"
                      rules="required"
                      label="Company Name"
                    />
                  </div>
                  <div class="col-md-6">
                    <TextInput
                      v-model="agency.email"
                      name="email"
                      rules="required|email"
                      label="Email"
                    />
                  </div>
                </div>
                <div class="row">
                  <div class="col-md-6">
                    <TextInput
                      v-model="agency.custom_url"
                      name="custom_url"
                      label="Custom URL"
                    />
                  </div>
                  <div class="col-md-6">
                    <div class="row">
                      <div class="col-6">
                        <TextInput
                          v-model="agency.subdomain"
                          name="subdomain"
                          rules="required|subdomain"
                          label="Subdomain"
                        />
                      </div>
                      <div class="col-6">
                        <TextInput
                          :value="whitelabelDomain"
                          :readonly="true"
                          label="&nbsp;"
                        />
                      </div>
                    </div>
                  </div>
                  <div class="col-md-6">
                    <div class="mt-2 mb-4 pt-2">
                      <span class="pr-2" style="font-weight:600;">OFF</span>
                      <b-form-checkbox
                        v-model="agency.free_fee"
                        name="check-button"
                        switch
                        inline
                      >
                        ON - Free fee
                      </b-form-checkbox>
                    </div>
                  </div>
                  <div class="col-md-6">
                    <div class="mt-2 pt-2">
                      <span class="pr-2" style="font-weight:600;">OFF</span>
                      <b-form-checkbox
                        v-model="agency.is_active_livechat"
                        name="check-button"
                        switch
                        inline
                      >
                        ON - Livechat
                      </b-form-checkbox>
                    </div>
                  </div>
                  <div class="col-md-6 mb-4">
                    <div class="mt-2 pt-2">
                      <span class="pr-2" style="font-weight:600;">OFF</span>
                      <b-form-checkbox
                        v-model="agency.is_active_loop"
                        name="check-button"
                        switch
                        inline
                      >
                        ON - Loop
                      </b-form-checkbox>
                    </div>
                  </div>
                  <div class="col-md-6 mb-4">
                    <div class="mt-2 pt-2">
                      <span class="pr-2" style="font-weight:600;">OFF</span>
                      <b-form-checkbox
                        v-model="agency.use_integration"
                        name="check-button"
                        switch
                        inline
                      >
                        ON - Integration Feature
                      </b-form-checkbox>
                    </div>
                  </div>
                  <div class="col-md-6 mb-4">
                    <div class="mt-2">
                      <span class="pr-2" style="font-weight:600;">OFF</span>
                      <b-form-checkbox v-model="agency.is_enable_import_contact" name="check-button" switch inline>
                        ON - Import contact
                      </b-form-checkbox>
                    </div>
                  </div>
                </div>
                
                <b-form-group>
                  <b-button
                    variant="primary"
                    :disabled="loadingCreate || (invalid && touched)"
                    type="submit"
                  >
                    <b-spinner v-if="loadingCreate" small />
                    <span v-else>Create</span>
                  </b-button>
                </b-form-group>
              </form>
            </ValidationObserver>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

export default {
  components: {
  },

  data() {
    return {
      agency: {
        name: '',
        email: '',
        free_fee: false,
      },
      loadingCreate: false,
    }
  },

  computed: {
    whitelabelDomain() {
      return this.$store.getters['app/whitelabelDomain']
    },
  },

  methods: {
    createAgency() {
      this.loadingCreate = true

      this.$store
        .dispatch('agency/create', this.agency)
        .then(() => {
          this.$router.push({ name: 'admin.agencies.index' })
          this.loadingCreate = false
        })
        .catch((err) => {
          if (err.response.data.errors) {
            this.$refs.updateForm.setErrors(err.response.data.errors)
          }
          this.loadingCreate = false
        })
    },
  },
}
</script>
